export default __webpack_public_path__ + "static/media/playerReel-logo.46bae97b.png";